import React, { useEffect, useState } from 'react';

interface StopWatchProps {
  initialTime: number;
  resetSignal: boolean;
  onReset: () => void;
}

const StopWatch: React.FC<StopWatchProps> = ({ initialTime, resetSignal, onReset }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    // 타이머가 0이 되면 카운트 정지
    if (timeLeft === 0) {
      onReset();
      return;
    }

    // 매 초마다 timeLeft 1 씩 감소
    const intervalId = setInterval(() => {
      setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
    }, 1000);

    // 컴포넌트가 언마운트 되거나 timeLeft 가 변경될때 마다 인터벌을 정리합니다.
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    if (resetSignal) {
      setTimeLeft(() => initialTime);
    }
  }, [resetSignal]);

  // 시간 표기
  const formatTimeLeft = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <>
      <p>{formatTimeLeft()}</p>
    </>
  );
};

export default StopWatch;
